import { t } from "@lingui/macro";
import { AboutPage as SharedAboutPage } from "@WahooFitness/wahoo-offline-mfe";
import Copyright from "./Copyright";

const SETTINGS_CAPACITOR_PLUGINS = ["Geolocation"];

function AboutPage() {
  return (
    <SharedAboutPage
      title={t`About`}
      copyright={<Copyright />}
      extraPlugins={SETTINGS_CAPACITOR_PLUGINS}
    />
  );
}

export default AboutPage;
